export default {
  chatbot: {
    toggle_label: "Léa-Assistentin öffnen",
    close_label: "Léa-Assistentin schließen",
    panel_label: "Léa-Assistentin",
    send_label: "Nachricht senden",
    stop_label: "Generierung stoppen",
    loading_label: "Léa schreibt…",
  },
};
